import './Footer.css'

import { useTranslation } from 'react-i18next'

import { Button } from '#design-system/component/Button/Button'
import { Joystick } from '#design-system/icons/joystick'

export const Footer = () => {
  const { t } = useTranslation()

  return (
    <footer className="shell-footer">
      <Button
        actionRole="ghost"
        href="/playground"
        icon={<Joystick />}
        label={t('shell.nav.playground')}
        tagType="a"
      />
    </footer>
  )
}
